import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getConnectedAccountStatusById = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        serviceCall({
            url: apiConstants.PAYMENT_GATEWAY.GET_CONNECTED_ACCOUNT_STATUS_BY_ID,
            method: 'get',
            data: data,
        })
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 